import sliders from '../../../src/js/shared/sliders';

'use strict';

const $ = jQuery.noConflict();

$(function() {

	const sliderProducts = {

		init: function() {
			this.sliderProductsInit();
			this.equalHeightTitle();
			$(window).on('load resize', () => {
				this.equalHeightTitle();
			});
		},

		sliderProductsInit: function() {
			const sliderConfig = {
				infinite: true,
				slidesToShow: 4,
				autoplay: false,
				speed: 400,
				dots: false,
				arrows: true,
				prevArrow: $('.js-products-slider__arr-prev'),
				nextArrow: $('.js-products-slider__arr-next'),
				// cssEase: 'linear',
				fade: false,
				responsive: [
					{
						breakpoint: 1199,
						settings: {
							slidesToShow: 3
						}
					},
					{
						breakpoint: 767,
						settings: {
							slidesToShow: 2
						}
					},
					{
						breakpoint: 500,
						settings: {
							slidesToShow: 1
						}
					}
				]
			};

			// Initialize slider with custom configuration
			sliders.initializeSlider('.js-products-slider', sliderConfig);
		},

		equalHeightTitle: function() {
			let maxHeight = 0;

			$('.products-slider__slider-box-title').each(function() {
				$(this).css('height', 'auto');
				maxHeight = Math.max(maxHeight, $(this).outerHeight());
			});

			$('.products-slider__slider-box-title').height(maxHeight);
		}
	};

	sliderProducts.init();

});
